var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9 C21,7,17,3,12,3z M12,18c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S12.6,18,12,18z M11.9,14c-0.4,0-0.8-0.3-0.9-0.7 c-0.2-0.5,0.1-1.1,0.6-1.3c0.6-0.2,2.3-1,2.3-2.1c0-0.5-0.2-0.9-0.5-1.3c-0.3-0.4-0.7-0.6-1.2-0.7c-0.5-0.1-0.9,0-1.4,0.2 c-0.4,0.2-0.7,0.6-0.9,1.1c-0.2,0.5-0.8,0.8-1.3,0.6C8.2,9.8,8,9.2,8.1,8.7C8.5,7.8,9.1,7,9.9,6.5c0.8-0.5,1.8-0.7,2.7-0.5 c0.9,0.2,1.8,0.6,2.4,1.4c0.6,0.7,0.9,1.6,0.9,2.6c0,2.6-3.3,3.8-3.7,3.9C12.1,14,12,14,11.9,14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.21f7a85cde7c8d9a1ac7d5ce077841cf.svg";
export { ForwardRef as ReactComponent };